export default __webpack_public_path__ + "static/media/partnerAd.a116db72.png";